{
    "Profile_Residents_Claim.claim": "Claim",
    "Profile_Residents_Claim.claimDetails": "Claim Details",
    "Profile_Residents_Claim.dateOfClaim": "Date of Claim",
    "Profile_Residents_Claim.claimReason": "Claim Reason",
    "Profile_Residents_Claim.lossAmount": "Loss Amount",
    "Profile_Residents_Claim.currentRisk": "Current Risk"
}
